//

export interface IPerson {
  name: string;
  firstName: string;
  middleName?: string;
  lastName: string;
  number?: string;
  dob?: string;
  sex?: string;
  taxId?: string;
}

export interface IPersonResponse {
  PersonDOB?: string;
  PersonFirstName: string;
  PersonLastName: string;
  PersonMiddleName?: string;
  PersonNumber?: string;
  PersonSex?: string;
  PersonTaxID?: string;
}

export const mapPersonResponse = ({
  PersonDOB,
  PersonFirstName,
  PersonLastName,
  PersonMiddleName,
  PersonNumber,
  PersonSex,
  PersonTaxID,
}: IPersonResponse): IPerson => {
  const mappedPerson = {
    name: `${PersonFirstName} ${PersonLastName}`,
    firstName: PersonFirstName,
    middleName: PersonMiddleName,
    lastName: PersonLastName,
    number: PersonNumber,
    dob: PersonDOB,
    sex: PersonSex,
    taxId: PersonTaxID,
  };
  return mappedPerson;
};
